export default __webpack_public_path__ + "static/media/icon-prev-single.af8aabcb.svg";